import React, { FC, useEffect, useState } from "react";
import { ConnectedProps, connect } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Button, Text, Tooltip } from "@fluentui/react-components";
import { Info16Regular } from "@fluentui/react-icons";

import { IRapComponentProperties } from "../../../../platform/Layout";
import { IUhfViewState } from "../../../../pages/Contracts";
import { ITestConfiguration } from "../../Contracts";
import { TestActions } from "../../redux/TestActions";
import { localizedStrings } from "../../../../common/localization/LocalizedStrings";
import { FlexContainer } from "../../../../common/components/FlexContainer/FlexContainer";

import * as TestSelectors from "../../redux/TestSelectors";

import "./UHFPreview.scss";

interface IUHFPreviewProvidedProps extends IRapComponentProperties {
    alpineTest?: boolean;
}

interface IUHFPreviewOwnProps {
    testConfig: ITestConfiguration;
}

export type IUHFPreviewProps = ConnectedProps<typeof connector> & IUHFPreviewProvidedProps;

const UHFPreviewInitializer: FC<IUHFPreviewProps> = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loadTime, setLoadTime] = useState<number>();
    let startLoad: number;

    useEffect(() => {
        if(props.testConfig.links.previewUrl) {
            startLoad = new Date().getTime();
        }
    }, [props.testConfig.links.previewUrl]);

    const onLoadFinished = () => {
        setLoadTime(new Date().getTime() - startLoad);
    }

    if(!props.testConfig?.partnerId && !(props.testConfig?.footerId || props.testConfig?.headerId)) {
        return <></>;
    }

    return (
        <>
            <FlexContainer direction="row">
                <Button as="a" className="c-preview-button" href={props.testConfig?.links?.serviceDemoUrl} target="_blank">{localizedStrings.TestView?.TestConfigurator?.openInNewWindow}</Button>
                <FlexContainer direction="row" flex style={{justifyContent: "flex-end", alignItems: "center"}}>
                    <Text as={"span"} style={{alignItems: "right", margin: 0}} weight={"bold"} size={400}>Load Time</Text>
                    <Tooltip
                        content={{
                            children: "This value represents the total time it took for the iFrame to load, which also includes the load time of React app being used to display the UHF in the iFrame. As a result, it may be higher than the actual time it took for the UHF service to respond.",
                        }}
                        positioning="above-start"
                        withArrow
                        relationship="label"
                    >
                        <Info16Regular style={{paddingTop: "3px", paddingLeft: "5px", paddingRight: "5px"}}/>
                    </Tooltip>
                    <Text as={"span"} style={{alignItems: "right", margin: 0}} weight={"bold"} size={400}>: {loadTime} ms</Text>
                </FlexContainer>
            </FlexContainer>
            <iframe id="frame" src={props.testConfig?.links?.previewUrl} className="c-preview" height={502} title="UHF Preview" onLoad={onLoadFinished}></iframe>
        </>
    );
}

function mapStateToProps(state: IUhfViewState, providedProps: IUHFPreviewProvidedProps): Partial<IUHFPreviewOwnProps> {
    return {
        ...providedProps,
        testConfig: TestSelectors.getTestConfig(state)
    };
}

const ActionsToDispatch = {
    setTestConfig: TestActions.setTestConfig
};

const connector = connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
);

export const UHFPreview = connector(UHFPreviewInitializer);